import React from 'react';
import { WrapperFlexOnboarding } from '../styles/onboarding.styles';
import TemplateLogin from './templates/template';
import { createTemplate } from '@/lib/templateSwitch';

export default function Login() {
  const template = createTemplate(TemplateLogin);
  return <WrapperFlexOnboarding>{template}</WrapperFlexOnboarding>;
}
